// @flow

import { css } from 'styled-components';

import { Fonts } from 'styles';

export const buttonDefault = css`
  text-transform: uppercase;
  ${Fonts.GOTHIC};
  font-weight: 600;
  font-size: 1.6rem;
  letter-spacing: 0.02em;
  line-height: 1;
`;
